import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentList:[],
    loading:false,
    cattleListAddComment:[],
    penListComment:[],
    cattleId:'',
    commentMode:false,
    penCommentMode:false
}

const listSlice=createSlice({
name:'list',

initialState,
reducers:{
    loginStartL:(state)=>{
        state.loading=true

    },
    loginSuccessL:(state,{payload})=>{
        state.loading=false;
        state.currentList=payload;
        

    },
    loginFailureL:(state)=>{


    },
    addCattleListComment:(state,{payload})=>{
        state.cattleListAddComment=payload
    },
    changeCommentMode:(state,{payload})=>{
        state.commentMode=!payload
    },
    addPenListComment:(state,{payload})=>{
        state.penListComment=payload
    },
    changePenMode:(state,{payload})=>{
        state.penCommentMode=!payload
    },
    addCattleId:(state,{payload})=>{
        state.cattleId=payload
    },
    logOutL:(state)=>{
        state.penCommentMode=false
        state.penListComment=[]
        state.loading=false;
        state.currentList=[];
        state.cattleListAddComment=[]
        state.commentMode=false
        state.cattleId=''
    }
    

}
})
export const {loginStartL,loginFailureL,loginSuccessL,logOutL,addCattleListComment,changeCommentMode,addPenListComment,changePenMode,addCattleId}=listSlice.actions

export default listSlice.reducer